import ReactMarkdown from 'react-markdown';

import Button from 'components/button/Button';
import {IPlan} from 'hooks/useStaticContent';
import Checkmark from '../checkmark/Checkmark';

const {background, text} = {
  text: ['text-white', 'text-black'],
  background: ['bg-brand-forest', 'bg-white'],
};

const Plan = ({
  title,
  active: providedActive,
  features,
  onPick,
  price = '',
  period,
  recommended,
  current,
  processing,
}: IPlan & {processing?: boolean}) => {
  const active = Boolean(providedActive);
  const colors = {
    background: background[active ? 0 : 1],
    text: text[active ? 0 : 1],
  };

  return (
    <div
      onClick={onPick}
      className={`
      cursor-pointer
      plan flex ${colors.text} transition-all overflow-hidden flex-col shadow ${
        colors.background
      } rounded-3xl shadow-brand-forest/20 px-8 py-6 md:min-h-[65vh] ${
        active ? '' : 'hover:bg-brand-forest/10'
      }
    `}
    >
      <small className="block text-center tracking-widest uppercase font-bold -mb-1 opacity-50">
        {recommended || current ? (
          current ? (
            'Current'
          ) : (
            'Recommended'
          )
        ) : (
          <span>&nbsp;</span>
        )}
      </small>
      <h1 className="text-4xl my-2 text-center font-bold">{title}</h1>
      <p className="text-grey5 mt-2 mb-2 text-md font-medium">
        What You'll Get
      </p>
      <div className="grow">
        <ReactMarkdown
          components={{
            li: (props) => (
              <div className="my-2 grid grid-cols-12">
                <Checkmark
                  className="w-4 h-4 inline-block mt-1"
                  color={active ? 'white' : '#345251'}
                />
                <span className="ml-2 inline col-span-11">
                  {props.children}
                </span>
              </div>
            ),
          }}
        >
          {features}
        </ReactMarkdown>
      </div>
      {Boolean(price) && (
        <div
          className={`border-t-[1px] border-grey5 mt-8 font-bold px-8 py-4 text-4xl border-dashed w-[200%] -mx-8`}
        >
          ${price}
          {Boolean(period) && (
            <span className="text-label font-medium text-sm">/{period}</span>
          )}
        </div>
      )}
      <Button
        onClick={onPick}
        disabled={current || processing}
        title="Subscribe"
        className={`rounded-xl ${
          !active ? 'opacity-0 hidden md:block' : 'disabled:opacity-50'
        } bg-white text-brand-forest`}
      />
    </div>
  );
};

export default Plan;
